import produce from 'immer';
import { omit } from 'lodash';
import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getListFilteredCards';

export const getListCardsData = (params) => {
    // delete unnecessary props for Api (this props needed only for FE)
    const fixedParams = produce(params, (draft) => {
        draft.cardCachedFilter.filter.filters.forEach((item) => {
            omit(item, ['currentValue', 'isSelected']);
            return item;
        });
    });
    // ==========================================================================
    return network.post(ENDPOINT, fixedParams).then((response) => {
        return response.data;
    });
};
